import * as types from '../mutations'
import Vue from 'vue'
import axios from 'axios'

const state = {
    locations: [],
    locationsFetched: false,
}

function findById(id, arr)
{
    for (let i = 0; i < arr.length; ++i)
    {
        if (arr[i].id === id)
        {
            return { index: i, obj: arr[i]}
        }
    }
    return null
}

const mutations = {

    [types.LOCATION_FETCH] (state, list)
    {
        state.locations = list
        state.locationsFetched = true
    },

    [types.LOCATION_ADD] (state, location)
    {
        state.locations.push(location)
    },

    [types.LOCATION_DELETE] (state, location)
    {
        const result = findById(location.id, state.locations)
        if (result)
        {
            state.locations.splice(result.index, 1)
        }
    },

    [types.LOCATION_UPDATE] (state, location)
    {
        const result = findById(location.id, state.locations)
        if (result)
        {
            Vue.set(state.locations, result.index, location)
        }
    },

}

const actions = {

    init({rootGetters, dispatch})
    {
        if (rootGetters.authLoggedIn)
            dispatch('locationCheck')
    },

    locationCheck({dispatch, state})
    {
        if (!state.locationsFetched)
        {
            dispatch('locationFetch')
        }
    },

    locationFetch({commit})
    {
        return new Promise(async(resolve, reject) => {
            const list = await axios.get(process.env.API_URL + '/v1/admin/locations')
            if (list)
            {
                commit(types.LOCATION_FETCH, list.data)
                resolve(list.data)
            } else {
                reject()
            }
        })
    },

    locationUpdate({commit}, location)
    {
        return new Promise((resolve, reject) => {
            commit(types.LOCATION_UPDATE, location)
            resolve()
        })
    },

    locationDelete({commit}, location)
    {
        return new Promise((resolve, reject) => {
            commit(types.LOCATION_DELETE, location)
            resolve()
        })
    },

    locationNew({commit}, location)
    {
        return new Promise((resolve, reject) => {
            commit(types.LOCATION_ADD, location)
            resolve()
        })
    },

}

const getters = {
    locationList: state => JSON.parse(JSON.stringify(state.locations))
}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/location.js